import { GetOrderDataQuery, OrderViewDataQuery } from "@saleor/graphql";
import { useFormik } from "formik";

import {
  changeOrderHeaderMapping,
  changeOrderLinesMapping,
  INIT_EMPTY_ORDERLINE,
  OrderHeaderMapping,
  orderLinesMapping
} from "../utils";
import useNotRefValidations from "./useNotRefValidations";

const useNotRefOrderData = (
  order: GetOrderDataQuery["getOrderData"],
  changeOrder: OrderViewDataQuery["orderViewData"],
  isChangeFlow: boolean,
  currentAction: "none" | "add" | "split" | "edit"
) => {
  const { HeaderSchema, ItemDetailsSchema } = useNotRefValidations(
    isChangeFlow,
    currentAction
  );
  const initHeaderdata = isChangeFlow
    ? changeOrderHeaderMapping(changeOrder)
    : OrderHeaderMapping(order);
  const initItemDetailsData = isChangeFlow
    ? changeOrderLinesMapping(changeOrder?.orderItems, {
        poNumber: changeOrder?.poNo,
        orderType: changeOrder?.orderType
      })
    : orderLinesMapping(order?.orderLines, {
        poNumber: order?.poNumber,
        orderType: order?.orderType
      });

  const formikHeader = useFormik<NotRefOrderHeader>({
    initialValues: initHeaderdata,
    validationSchema: HeaderSchema,
    enableReinitialize: true,
    validateOnMount: true,
    onSubmit: () => {
      //
    }
  });

  const formikItemDetails = useFormik({
    initialValues: {
      currentIndex: -1,
      isSplitSubmit: false,
      lines:
        initItemDetailsData?.length || (isChangeFlow && changeOrder)
          ? initItemDetailsData
          : [INIT_EMPTY_ORDERLINE("10")]
    },
    validationSchema: ItemDetailsSchema,
    enableReinitialize: true,
    validateOnMount: true,
    validateOnBlur: true,
    validateOnChange: true,
    onSubmit: () => null
  });

  const formikCPItemDetails = useFormik({
    initialValues: {
      lines: []
    },
    onSubmit: () => null
  });

  return {
    formikHeader,
    formikItemDetails,
    formikCPItemDetails
  };
};

export default useNotRefOrderData;
